<template>
  <div class="roi-chart">
    <canvas :id="chartId"></canvas>

    <img :id="imageId" :alt="label" />
  </div>
</template>

<script>
import { createChart } from './pie-chart';

export default {
  name: 'SummaryGraph',

  props: {
    /** @type {import('vue').PropOptions<ChartDataPoint[]>} */
    values: {
      type: Array,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },
  },

  data() {
    const rand = Math.round(Math.random() * 1000);
    return {
      /** @type {Chart=} */
      chart: undefined,
      chartId: `chart-${rand}`,
      imageId: `image-${rand}`,
    };
  },

  mounted() {
    this.chart = createChart({
      chartId: this.chartId,
      imageId: this.imageId,
      dataPoints: this.values,
      label: this.label,
    });
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.destroy();
  },
};

/**
 * @typedef {import('chart.js').Chart} Chart
 * @typedef {import('./pie-chart').ChartDataPoint} ChartDataPoint
 */
</script>
